import { useTranslation } from 'react-i18next';
import { useState } from "react";
import CustomCurrencyFormat from '../utils/CurrencyFormat';
import outstandimg from '../../assets/images/outstandimg.png';
import Viewquotepopup from "../bill/Viewquotepopup";
import Viewinvoicepopup from "../bill/Viewinvoicepopup";
import Orderdelivery from "../bill/Orderdelivery";
import { Link } from "react-router-dom";
import billTotal from '../utils/BillTotal';

function Outstanding(props) {
  const { t } = useTranslation();
  const postdate = new Date(props.post_date);
  const deliveryDate = new Date(props.delivery_date);

  const [isQuoteActive, setIsQuoteActive] = useState(false);
  const [isInvoiceActive, setIsInvoiceActive] = useState(false);
  const [isOrderActive, setIsOrderActive] = useState(false);

  const handleRepeatOrderClick = () => {
    setIsOrderActive(true);
  };

  const handleCloseOrderPopup = () => {
    setIsOrderActive(false);
  };
  const dollar = props.invoice?.dollars_spent ? parseFloat(props.invoice?.dollars_spent["$numberDecimal"]) : 0;

  const finalTotal = props.invoice
    ? billTotal(
      parseFloat(props.invoice?.inv_total["$numberDecimal"]),
      parseFloat(props.invoice?.shipping["$numberDecimal"]),
      parseFloat(props.invoice?.inv_discount["$numberDecimal"]),
      parseFloat(props.invoice?.customer_discount),
      dollar,
      parseFloat(props.tax["$numberDecimal"])
    )
    : parseFloat(props.total["$numberDecimal"]);


  return (

    <div className="billitem_slides outstanding">
      <div className="billdate">
        <div className="billdate_data">
          <p><span>{postdate.getDate()}</span>
            <span>{postdate.toLocaleString('en-US', { month: 'short' })}</span>
            <span>{postdate.getFullYear()}</span></p>
        </div>
        <div className="billdate_list">
          <div className="billdate_list_t">
            <div className="billdate_list_t_l">
              <div className="">
                {props.invoice_no} <span className={props?.invoice?.paid_status === 'PAID' ? 'paid_st' : 'outstanding_st'}><img src={outstandimg} alt="user" />{props?.invoice?.paid_status}</span>
              </div>
              <h3><CustomCurrencyFormat amount={finalTotal} /></h3>
            </div>
            <div className="billdate_list_t_r">
              <span></span>
              <p>{t('delivered')} {t('on')} {deliveryDate.getDate()} / {deliveryDate.toLocaleString('en-US', { month: '2-digit' })}</p>
            </div>
          </div>
          <div className="billdate_list_b">
            {props.quotation &&
              <Link to={`/quote/pdf/${props.quotation._id} `} target='_blank' className="view_quote" >{t('view_quote')}</Link>
            }
            {props.invoice &&
              <Link to={`/invoice/pdf/${props.invoice._id} `} target='_blank' className="view_invoice" >{t('view_invoice')}</Link>
            }
            {props.status == '4' &&
              <button className="repeat_order" onClick={handleRepeatOrderClick}>
                {t('repeat_order')}
              </button>
            }
          </div>
        </div>
      </div>

      {props.reference_no &&
        <Orderdelivery
          isActive={isOrderActive}
          onClose={handleCloseOrderPopup}
          {...props}
        />
      }
    </div>

  );
}

export default Outstanding;
